.card {
  display: flex;
  flex-direction: column;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

.heading {
  padding: 16px 18px 10px;
  font-size: 18px;
}

.count {
  font-weight: 500;
  color: var(--ink-2);
}

.empty {
  padding: 0 18px 16px;
  color: var(--ink-2);
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 60px;
  padding: 10px 18px;
  border-top: 1.5px solid var(--ink);
  color: var(--ink);
  text-decoration: none;
}

.lines {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.who {
  overflow: hidden;
  font-size: 15px;
  font-weight: 700;
  text-overflow: ellipsis;
}

.detail {
  font-size: 13px;
  color: var(--ink-2);
}

.chevron {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  background-color: var(--ink);
  -webkit-mask: url('./chevron.svg') no-repeat center / contain;
  mask: url('./chevron.svg') no-repeat center / contain;
}
